import { NavLink } from 'react-router-dom';
import {
  Banknote,
  ClipboardList,
  FileText,
  Handshake,
  Images,
  LayoutDashboard,
  Mail,
  Megaphone,
  Newspaper,
  Palmtree,
  Users,
} from 'lucide-react';
import { clsx } from '../utils/cn.js';
import BrandLogo from '../components/BrandLogo.jsx';

const items = [
  { to: '/admin/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/admin/carrusel', label: 'Carrusel', icon: Images },
  { to: '/admin/home-popup', label: 'Avisos inicio', icon: Megaphone },
  { to: '/admin/noticias', label: 'Noticias', icon: Newspaper },
  { to: '/admin/vacaciones', label: 'Sedes vacacionales', icon: Palmtree },
  { to: '/admin/creditos', label: 'Créditos', icon: Banknote },
  { to: '/admin/convenios', label: 'Convenios', icon: Handshake },
  { to: '/admin/normatividad', label: 'Normatividad', icon: FileText },
  { to: '/admin/entes-administrativos', label: 'Entes administrativos', icon: Users },
  { to: '/admin/contacto', label: 'Contacto / PQRS', icon: Mail },
  { to: '/admin/auditoria', label: 'Auditoría', icon: ClipboardList },
];

export default function AdminSidebar({ onNavigate }) {
  return (
    <aside className="flex h-full w-full flex-col border-r border-white/10 bg-brand-navy text-white">
      <div className="flex items-center gap-3 border-b border-white/10 px-5 py-6">
        <div className="h-10 w-28 shrink-0 rounded-lg bg-white/10 p-1.5 ring-1 ring-white/15">
          <BrandLogo className="max-h-7" alt="Coonaltragas" />
        </div>
        <div className="min-w-0">
          <p className="truncate font-display text-sm font-semibold">Dashboard</p>
          <p className="truncate text-xs text-white/60">Administración</p>
        </div>
      </div>

      <nav className="flex-1 space-y-1 px-3 py-4">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            onClick={() => onNavigate?.()}
            className={({ isActive }) =>
              clsx(
                'flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition',
                isActive
                  ? 'bg-white/15 text-white shadow-inner shadow-black/20'
                  : 'text-white/70 hover:bg-white/10 hover:text-white'
              )
            }
          >
            <item.icon className="h-4 w-4 shrink-0 opacity-90" />
            {item.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
